<ion-item class="template-manual-input-container" 
[style.--dynamic-margin-top]="dynamicMarginTop ? dynamicMarginTop + 'vh' : '0'"
>
  <ion-label position="stacked">
    <ion-img [src]="labelIcon"></ion-img>
    {{ label }}
  </ion-label>
  <div class="input-view">
    <ion-button
      fill="clear"
      (click)="openTemplate.emit($event)"
      *ngIf="templateEnable"
    >
      <ion-icon
        slot="icon-only"
        src="./assets/icon/template-icon.svg"
      ></ion-icon>
    </ion-button>
    <ion-textarea
      [ngClass]="{ error: isInvalid }"
      #myInput
      rows="1"
      [disabled]="!inputEnable"
      autoGrow="true"
      [(ngModel)]="value"
      [placeholder]="placeholderText"
      spellcheck="true"
      autocorrect="on"
      autocapitalize="sentences"
    ></ion-textarea>
  </div>
  <ion-button
    *ngIf="!hideClearBTN"
    class="close-icon-btn"
    slot="end"
    fill="clear"
    (click)="onRemove.emit($event)"
  >
    <ion-icon name="close-circle" slot="icon-only"></ion-icon>
  </ion-button>
</ion-item>
